import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`

export const StateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${props => props.theme.whiteLabel.spacing.sp24};
  flex: 1;
  min-height: 0;
`

export const EmptyMessage = styled(Text)`
  width: 100%;
  text-align: center;
`
